export const User_log_req="User_log_req";
export const User_log_suc="User_log_suc";
export const User_log_fail="User_log_fail";

export const User_reg_req="User_reg_req";
export const User_reg_suc="User_reg_suc";
export const User_reg_fail="User_reg_fail";
export const user_logout="user_logout";

export const User_det_req="User_det_req";
export const User_det_suc="User_det_suc";
export const User_det_fail="User_det_fail";